import { useCallback, useState } from 'react';
import cx from 'classnames';

import { CUSTOM_BUTTON_SIZE, CustomButton } from 'src/components/CustomButton';
import { CustomMarkdown } from 'src/components/CustomMarkdowm';
import ErrorPanel from 'src/components/ErrorPanel';
import { loginToTeads } from 'src/utils/lib/oauth';

import { useStyles } from './useStyles';

export const TeadsLogin = ({
  className,
  loading,
  disabled,
  onStart,
  onSuccess,
  onError,
  error,
}) => {
  const styles = useStyles();
  const [processing, setProcessing] = useState(false);

  const handleSubmit = useCallback(
    async (e) => {
      try {
        e.preventDefault();
        setProcessing(true);
        onStart();

        const { token } = await loginToTeads();
        onSuccess({ token });
      } catch (e) {
        onError(e);
      } finally {
        setProcessing(false);
      }
    },
    [onStart, onSuccess, onError]
  );

  return (
    <form
      className={cx(styles.root, className)}
      onSubmit={handleSubmit}
    >
      {error && (
        <ErrorPanel
          classes={{ root: styles.errorPanel }}
          type="warning"
          text={<CustomMarkdown text={error} />}
        />
      )}
      <CustomButton
        loading={loading || processing}
        disabled={disabled || loading || processing}
        size={CUSTOM_BUTTON_SIZE.large}
        type="submit"
        fullWidth
      >
        Login with Teads
      </CustomButton>
    </form>
  );
};
